import React from 'react';

import GrafanaIcon from './images/grafana.svg';

export const GrafanaLogo = () => {
  return <img height="18" src={GrafanaIcon} alt="Grafana logo" />;
};
